export type VisitorBookingVisitAction = "checkIn" | "checkOut" | "cancel" | "reject";

type VisitorBookingVisitActionSnackbarKeys = {
  success: string;
  failed: string;
  notAvailable: string;
};

const VISITOR_BOOKING_VISIT_ACTION_SNACKBAR_KEYS: Record<
  VisitorBookingVisitAction,
  VisitorBookingVisitActionSnackbarKeys
> = {
  checkIn: {
    success: "_visitorBookings_checkInSuccess",
    failed: "_visitorBookings_checkInFailed",
    notAvailable: "_visitorBookings_checkInNotAvailable"
  },
  checkOut: {
    success: "_visitorBookings_checkOutSuccess",
    failed: "_visitorBookings_checkOutFailed",
    notAvailable: "_visitorBookings_checkOutNotAvailable"
  },
  cancel: {
    success: "_visitorBookings_cancelVisitSuccess",
    failed: "_visitorBookings_cancelVisitFailed",
    notAvailable: "_visitorBookings_cancelVisitNotAvailable"
  },
  reject: {
    success: "_visitorBookings_rejectVisitSuccess",
    failed: "_visitorBookings_rejectVisitFailed",
    notAvailable: "_visitorBookings_rejectVisitNotAvailable"
  }
};

export function getVisitorBookingVisitActionSnackbarKeys(
  action: VisitorBookingVisitAction
): VisitorBookingVisitActionSnackbarKeys {
  return VISITOR_BOOKING_VISIT_ACTION_SNACKBAR_KEYS[action];
}
